<template>
  <v-chip
    small
    v-if="text"
    >{{ text }}</v-chip
  >
  <span v-else> - </span>
</template>

<script>
export default {
  props: {
    value: String,
  },

  computed: {
    colorize() {
      if (this.statusList[this.status]) {
        return this.statusList[this.status];
      }
      return {
        color: "secondary",
        text: this.status ? this.status : "-",
      };
    },
    color() {
      return this.colorize.color;
    },
    text() {      
        return this.value;
    },
  },
};
</script>